import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { color, fontSize, spacing } from '../theme'

const activeColor = color.success
const inactiveColor = color.disabledBg

const StyledProgressBar = styled.ul`
   display: flex;
   padding-left: 0;
   width: 100%;
   margin-top: ${spacing.ml};
   position: relative;
   z-index: 0;
`

const StepTemplate = styled.li`
   color: ${color.text};
   flex: 2;
   line-height: 2;
   list-style-type: none;
   padding-bottom: 1rem;
   position: relative;
   text-align: center;
   width: auto;
   font-size: ${fontSize.sm};

   /* Plupp */
   &:before {
      content: '';
      display: block;
      position: absolute;
      border-radius: 50%;
      background: ${color.background};
      border: 3px solid ${inactiveColor};
      height: 1rem;
      width: 1rem;
      left: calc(50% - 0.5rem);
      top: -1rem;
      z-index: 2;
   }

   &:first-child,
   &:last-child {
      flex: 1;
   }

   &.done::before,
   &.current::before {
      border: 3px solid ${activeColor};
   }

   /* Line */
   &:after {
      content: '';
      display: block;
      background: ${inactiveColor};
      width: 100%;
      height: 0.1rem;
      top: -0.5rem;
      position: absolute;
      z-index: 1;
   }

   &.current:after {
      background: linear-gradient(
         90deg,
         ${activeColor} 0%,
         ${activeColor} 50%,
         ${inactiveColor} 51%,
         ${inactiveColor} 100%
      );
   }

   &.done:after {
      background: ${activeColor};
   }

   /* First one current */
   &.current:first-of-type:after {
      background: ${inactiveColor};
   }

   /* Last one current */
   &.current:last-of-type:after {
      background: ${activeColor};
   }

   /* Positioning pseudo elements */
   /* Left */
   &:first-child {
      text-align: left;
   }
   &:first-child:before {
      left: 0;
   }

   /* Right */
   &:last-child {
      text-align: right;
   }
   &:last-child:before {
      right: 0;
      left: auto;
   }
`

export const ProgressBar = ({ children }) => {
   return <StyledProgressBar>{children}</StyledProgressBar>
}

export const ProgessStep = ({ label, progress }) => (
   <StepTemplate className={progress}>{label}</StepTemplate>
)

// percentage = sum(done) / sum(steps)

ProgressBar.propTypes = {
   children: PropTypes.node.isRequired
}

ProgressBar.defaultTypes = {
   children: PropTypes.object
}

ProgessStep.propTypes = {
   /** Text label */
   label: PropTypes.string,
   /** Current state of step */
   progress: PropTypes.oneOf(['done', 'current', 'upcoming'])
}

ProgessStep.defaulProps = {
   label: 'Label'
}
